<script setup>
import {computed} from "vue";
const props = defineProps(['value', 'uom']);
const partials = {0: '', 1: '¼', 2: '½', 3: '¾'};
const formattedValue = computed(() => {
    const base = Math.floor(props.value);
    const partial = Math.floor((props.value - base) * 4);
    return '' + (base > 0 ? base : '') + partials[partial];
})
</script>

<template>
    <span>{{ formattedValue }} {{ uom }}</span>
</template>
